<template>
  <v-app>
    <Header :isPublic="true" />
    <v-main>
      <div id="body">
      <v-row style="margin-left: 30px">
        <v-col cols="12" md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Processo"
            v-model="filtro.numeroProcesso"
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="CPF/CNPJ"
            v-model="filtro.cpfCnpj"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Sancionado"
            v-model="filtro.sancionado"
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Órgao"
            v-model="filtro.orgao"
          />
        </v-col>

        <v-col cols="12" md="2" style="margin-top: 1.8%">
          <v-btn
            style
            color="primary"
            small
            depressed
            :loading="loadingBusca"
            :disabled="loadingBusca"
            @click="buscar()"
          >
            <v-icon small>fa-search</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-alert v-if="erroServico" type="error" outlined dense class="mt-4">
        Não foi possível consultar as sanções no momento. Tente novamente em instantes.
      </v-alert>

      <v-row justify="center">
        <v-col cols="12" md="12">
          <template>
            <v-data-table
              @click:row="abrirDialog"
              :headers="headers"
              :items="lista"
              :items-per-page="10"
              :loading="loadingBusca"
              class="elevation-1 mytable"
              no-results-text="A busca não trouxe resultados."
              :no-data-text="erroServico ? 'Não foi possível carregar os dados.' : 'A busca não trouxe resultados.'"
            >
              <template v-slot:loading>
                <LoadingSpinner text="Carregando sanções... aguarde." />
              </template>
              <template v-slot:item.inicioSancaoFormatada="{ item }">
                <span>
                  {{
                    item.inicioSancao
                      ? $moment(item.inicioSancao).format("DD/MM/YYYY")
                      : "Não Informado"
                  }}
                </span>
              </template>
              <template v-slot:item.fimSancaoFormatada="{ item }">
                <span>
                  {{
                    item.fimSancao
                      ? $moment(item.fimSancao).format("DD/MM/YYYY")
                      : "Não Informado"
                  }}
                </span>
              </template>
            </v-data-table>
          </template>

          <v-dialog v-model="dialog" max-width="700px">
            <v-card>
              <v-card-title class="grey lighten-2"
                >Referente ao Processo: {{ sancao.numeroProcesso }}
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        disabled
                        class="font-weight-black"
                        label="Processo"
                        v-model="sancao.numeroProcesso"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="8">
                      <v-text-field
                        disabled
                        class="font-weight-black"
                        label="Órgao"
                        v-model="sancao.orgao"
                      ></v-text-field>
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col cols="12" md="8">
                      <v-text-field
                        disabled
                        class="font-weight-black"
                        label="Sancionado"
                        v-model="sancao.nome"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        disabled
                        class="font-weight-black"
                        label="CPF/CNPJ"
                        v-model="sancao.cpfCnpj"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <v-text-field
                        disabled
                        class="font-weight-black"
                        type="date"
                        label="Data Inicio"
                        v-model="sancao.inicioSancao"
                      />
                    </v-col>
                    <v-col md="3" v-if="sancao.fimSancao">
                      <v-text-field
                        disabled
                        class="font-weight-black"
                        type="date"
                        label="Data Fim"
                        v-model="sancao.fimSancao"
                      />
                    </v-col>
                    <v-col md="3" v-else>
                      <v-text-field
                        disabled
                        class="font-weight-black"
                        label="Data Fim"
                        value="Não Informado"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                      <v-textarea
                        disabled
                        class="font-weight-black"
                        rows="2"
                        outlined
                        auto-grow
                        counter
                        name="sancaoArea"
                        label="Sanção"
                        v-model="sancao.sancao"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                      <v-textarea
                        disabled
                        class="font-weight-black"
                        rows="2"
                        outlined
                        auto-grow
                        counter
                        name="legalArea"
                        label="Fundamento Legal"
                        v-model="sancao.fundamentoLegal"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row v-if="sancao.observacao">
                    <v-col cols="12" md="12">
                      <v-textarea
                        disabled
                        class="font-weight-black"
                        rows="2"
                        outlined
                        auto-grow
                        counter
                        name="obsArea"
                        label="Observação"
                        v-model="sancao.observacao"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false"
                  >Fechar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/template/Header.vue";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";
import sancaoService from "@/service/SancaoService";
export default {
  components: {
    Header,
    LoadingSpinner
  },
  data() {
    return {
      dialog: false,
      loadingBusca: false,
      erroServico: false,
      filtro: {
        numeroProcesso: null,
        orgao: null,
        cpfCnpj: null,
        sancionado: null,
        inicioSancao: null,
        fimSancao: null,
      },
      lista: [],
      sancao: {
        orgao: null,
        numeroProcesso: null,
        cpfCnpj: null,
        nome: null,
        fundamentoLegal: null,
        sancao: null,
      },
      headers: [
        { text: "Sancionado", value: "nome", sortable: false, width: "25%" },
        { text: "Processo", value: "numeroProcesso", sortable: false },
        { text: "Cpf / Cnpj", value: "cpfCnpj", sortable: false, width: "15%" },
        {
          text: "Data Inicio",
          value: "inicioSancaoFormatada",
          sortable: false,
        },
        { text: "Data Fim", value: "fimSancaoFormatada", sortable: false },
        { text: "Órgão", value: "orgao", sortable: false, width: "25%" },
      ],
    };
  },
  methods: {
    buscar() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.loadingBusca = true;
      this.erroServico = false;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      sancaoService
        .buscarSancaoFiltro(this.filtro)
        .then((result) => (this.lista = result || []))
        .catch(() => {
          // falha real (rede/API fora do ar): aviso de indisponibilidade
          this.lista = [];
          this.erroServico = true;
        })
        .finally(() => (this.loadingBusca = false));
    },
    abrirDialog(item) {
      Object.assign(this.sancao, item);
      this.dialog = true;
    },
  },
};
</script>

<style>
</style>